<template>
  <div class="member-page">
    <van-nav-bar
      title="会员中心"
      left-text="返回"
      left-arrow
      fixed
      :placeholder="true"
      @click-left="goBack"
    />
    <!-- 等级展示区域 -->
    <div class="level-display">
      <div class="level-info">
        <div class="level-center">
          <div class="user-circle">
            <div class="user-name">{{ userInfo.nickName || userInfo.username || '用户' }}</div>
            <div class="user-id">ID: {{ userInfo.userId || '--' }}</div>
            <div class="user-exp">经验值: {{ userInfo.currentExp || 0 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 当前等级信息 -->
    <div class="current-level">
      <div class="level-card">
        <div class="level-main">
          <div class="level-left">
            <div class="level-title">
              <span class="crown-icon">👑</span>
              <span>当前等级</span>
            </div>
            <div class="level-info">
              <div class="level-name">{{ userInfo.memberLevel || 'Lv.1' }}</div>
              <div class="growth-text">成长值已达到{{ userInfo.currentExp || 0 }}点</div>
            </div>
          </div>
          <div class="level-icon hexagon">
            <div class="level-image-container">
              <div class="level-text-overlay">{{ userInfo.memberLevel || 'Lv.1' }}</div>
            </div>
          </div>
        </div>
        <div class="progress-section">
          <div class="progress-bar">
            <div class="progress" :style="{ width: getProgressPercent() + '%' }"></div>
          </div>
          <div class="info-row">
            <div class="exp-value">经验值：{{ userInfo.currentExp || 0 }}/{{ userInfo.nextLevelExp || 100 }}</div>
            <div class="next-level">{{ getNextLevel(userInfo.memberLevelId || 1) }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 权限展示区域 -->
    <div class="permissions-grid">
      <div class="permission-item" v-for="(item, index) in permissions" :key="index"
           :class="{ 'active': item.active }">
        <div class="permission-icon">
          <div class="permission-image-container">
            <div class="permission-level-text">{{ getPermissionLevel(index + 1) }}</div>
          </div>
        </div>
        <div class="permission-info">
          <div class="permission-title">{{ item.title }}</div>
          <div class="permission-count">{{ item.count }}</div>
          <div class="permission-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'

export default {
  name: 'MemberPage',
  data() {
    return {
      userInfo: {},
      permissions: [
        {
          title: '待确认+待上报',
          count: '3单',
          desc: '自动竞价',
          active: true
        },
        {
          title: '待确认+待上报',
          count: '5单',
          desc: '自动竞价',
          active: true
        },
        {
          title: '待确认+待上报',
          count: '8单',
          desc: '自动竞价',
          active: true
        },
        {
          title: '待确认+待上报',
          count: '12单',
          desc: '自动竞价',
          active: true
        },
        {
          title: '待确认+待上报',
          count: '18单',
          desc: '自动竞价',
          active: false
        },
        {
          title: '待确认+待上报',
          count: '25单',
          desc: '自动竞价等',
          active: false
        }
      ]
    }
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    // 获取用户信息
    getUserInfo() {
      Api.getUserInfoNew().then(res => {
        console.log('会员中心用户信息:', res);
        this.userInfo = res;
        // 根据会员等级设置权限状态
        this.updatePermissions(res.memberLevelId || 1);
      }).catch(error => {
        console.error('获取用户信息失败:', error);
      });
    },
    // 计算进度百分比
    getProgressPercent() {
      const current = this.userInfo.currentExp || 0;
      const next = this.userInfo.nextLevelExp || 100;
      if (next === 0) return 100;
      return Math.min((current / next) * 100, 100);
    },
    // 获取下一等级
    getNextLevel(levelId) {
      const nextLevel = Math.min(levelId + 1, 6);
      return `Lv.${nextLevel}`;
    },
    // 根据会员等级更新权限状态
    updatePermissions(levelId) {
      this.permissions.forEach((permission, index) => {
        // 根据等级ID设置权限是否激活
        // 这里可以根据实际业务逻辑调整
        permission.active = index < levelId;
      });
    },
    getPermissionLevel(level) {
      // Implement the logic to get the permission level text based on the level
      // This is a placeholder and should be replaced with the actual implementation
      return `Lv.${level}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.member-page {
  min-height: 100vh;
  background: #f8f9fa;
  color: #333;
  padding-bottom: 20px;
  position: relative;

  .back-button {
    position: absolute;
    left: 15px;
    top: 15px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    &::before {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      border-left: 2px solid #333;
      border-bottom: 2px solid #333;
      transform: rotate(45deg);
    }
  }

  .level-display {
    padding: 20px 20px;
    
    .level-info {
      position: relative;
      width: 100%;
      margin: 0 auto;
      text-align: center;

      .level-center {
        .user-circle {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: 2px solid rgba(255, 255, 255, 0.3);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);

          .user-name {
            font-size: 16px;
            font-weight: bold;
            color: #fff;
            margin-bottom: 4px;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
            text-align: center;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .user-id {
            font-size: 11px;
            color: rgba(255, 255, 255, 0.9);
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            text-align: center;
            margin-bottom: 4px;
          }

          .user-exp {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.9);
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            text-align: center;
          }
        }
      }
    }
  }

  .current-level {
    padding: 0 15px;
    margin-bottom: 20px;

    .level-card {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 16px;
      padding: 16px;
      box-shadow: 0 4px 20px rgba(102, 126, 234, 0.2);
      color: white;

      .level-main {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .level-left {
          flex: 1;
          padding-right: 15px;

          .level-title {
            display: flex;
            align-items: center;
            margin-bottom: 12px;

            .crown-icon {
              font-size: 16px;
              margin-right: 4px;
            }

            span {
              font-size: 14px;
              color: #fff;
            }
          }

          .level-info {
            .level-name {
              font-size: 20px;
              font-weight: bold;
              color: #fff;
              margin-bottom: 4px;
            }

            .growth-text {
              font-size: 12px;
              color: rgba(255, 255, 255, 0.8);
            }
          }
        }

        .level-icon {
          width: 60px;
          height: 60px;
          margin-top: -5px;

          &.hexagon {
            clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
            background: rgba(255, 255, 255, 0.25);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px;
          }

          .level-image-container {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .level-text-overlay {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              font-size: 16px;
              font-weight: 700;
              color: #fff;
              text-shadow: 
                1px 1px 2px rgba(0, 0, 0, 0.6),
                0 0 6px rgba(0, 0, 0, 0.4);
              z-index: 2;
              white-space: nowrap;
              letter-spacing: 0.5px;
            }
          }
        }
      }

      .progress-section {
        .progress-bar {
          width: 100%;
          height: 4px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 2px;
          margin-bottom: 5px;

          .progress {
            height: 100%;
            background: white;
            border-radius: 2px;
            transition: width 0.3s ease;
          }
        }

        .info-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 5px;

          .exp-value {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.8);
          }

          .next-level {
            font-size: 12px;
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }
  }

  .permissions-grid {
    padding: 0 15px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-top: 15px;

    .permission-item {
      background: white;
      border-radius: 16px;
      padding: 15px 10px;
      text-align: center;
      transition: all 0.3s ease;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      border: 1px solid #f0f0f0;
      min-height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &.active {
        .permission-icon {
          opacity: 1;
        }

        .permission-info {
          .permission-title,
          .permission-count,
          .permission-desc {
            opacity: 1;
          }

          .permission-count {
            color: #667eea;
          }
        }
      }

      &:not(.active) {
        .permission-icon {
          opacity: 0.6;
        }

        .permission-info {
          .permission-title,
          .permission-count,
          .permission-desc {
            opacity: 0.6;
          }

          .permission-count {
            color: #999;
          }
        }
      }

      .permission-icon {
        width: 40px;
        height: 40px;
        margin: 0 auto 12px;
        
        .permission-image-container {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 50%;
          border: 2px solid rgba(255, 255, 255, 0.3);

          .permission-level-text {
            font-size: 13px;
            font-weight: 700;
            color: #fff;
            text-shadow: 
              1px 1px 2px rgba(0, 0, 0, 0.6),
              0 0 4px rgba(0, 0, 0, 0.4);
            white-space: nowrap;
            letter-spacing: 0.5px;
          }
        }
      }

      .permission-info {
        .permission-title {
          font-size: 11px;
          margin-bottom: 6px;
          color: #333;
          font-weight: 500;
        }

        .permission-count {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 6px;
          color: #333;
        }

        .permission-desc {
          font-size: 11px;
          color: #666;
          line-height: 1.3;
        }
      }
    }
  }
}
</style>
